export const environment = {
  production: false,
  apiUrl: "https://apis.flexospaces.com",
  s3_bucket_path: "worker-app",
  mapKey: "AIzaSyCOAhd885zH5TvinKCm3-rhDvgndqzoQyU",
  webDomain: "",
  clientId: "696066348928-dpugnnhq6v9ou191b40dcm7mmh4esuto.apps.googleusercontent.com",
  HOST_WEBLINK: "https://host.flexospaces.com"
};